import axios, {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosRequestHeaders,
  AxiosResponse,
  CreateAxiosDefaults,
} from "axios";
import Global from "@/utils/global";
import * as cookie from "cookie";
import { Storage } from "@/utils/storage";
import { logout, getDeviceId } from "./user";
import { StatusCode } from "@/utils/statusCode";

// 统一接口返回值
export interface ApiResponse<T> {
  data: T;
  errorData: any;
  message: string;
  status: number;
  successful: boolean;
  cost: number;
}

const config: CreateAxiosDefaults<any> = {
  method: "get",
  // 基础url前缀
  // baseURL: `http://localhost:3000/`,
  baseURL: `${Global.apiUrl}/`,
  // 请求头信息
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    "X-Timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
  },
  // 参数
  data: {},
  // 设置超时时间
  timeout: 15000,
  // 携带凭证
  withCredentials: true,
  // 返回数据类型
  responseType: "json",
};

async function handleError() {
  if (Storage.getItem("userInfo")) {
    Storage.removeItem("userInfo");
    await logout();
    location.reload();
  } else {
    if (location.pathname !== "/orders") {
      document.getElementById("signInBtn")?.click();
    }
  }
}

export class ApiClient {
  private readonly api: AxiosInstance;
  constructor() {
    let failedQueue: any[] = [];

    const processQueue = () => {
      failedQueue.forEach((promise) => {
        promise.resolve();
      });
      failedQueue = [];
    };

    this.api = axios.create({
      ...config,
    });

    this.api.interceptors.request.use(
      async (config) => {
        console.log("客户端 config.url : ", config.url);

        if (config.url?.includes('/member/tourists/gen/id')) {
          // @ts-ignore
          config.headers = {
            ...config.headers,
          } as AxiosRequestHeaders;
        } else {
          let deviceId = "";
          if (typeof window !== "undefined") {
            const cookies = document.cookie;
            const parsedCookies = cookie.parse(cookies);

            // console.log("cookies : ", JSON.stringify(parsedCookies));

            deviceId = parsedCookies.deviceId || parsedCookies.deviceid || "";

            if (!deviceId) {
              const deviceData = await getDeviceId();
              const touristsId = deviceData.data.touristsId;
              deviceId = touristsId;
              // cookies.set("deviceId", deviceId, { path: "/" });
            }
          }

          // @ts-ignore
          config.headers = {
            ...config.headers,
            deviceId: deviceId,
          } as AxiosRequestHeaders;
        }

        return config;
      },
      (error) => {
        return error;
      },
    );

    this.api.interceptors.response.use(
      (response) => {
        const originalRequest = response.config; // 获取原始请求

        if (response.data.code === StatusCode.Unauthorized) {
          handleError();

          return new Promise((resolve, reject) => {
            failedQueue.push({
              resolve: () => {
                resolve(this.api(originalRequest));
              },
              reject: (err: any) => reject(err),
            });
          });
        } else if (response.status === 200) {
          if (failedQueue.length > 0 && !!Storage.getItem("userInfo")) {
            processQueue();
          }
        }

        return response;
      },
      (error) => {
        let reason = error;

        if (error && error.response) {
          if (error.response.status === StatusCode.Unauthorized) {
            handleError();
          }
        }

        return Promise.reject(reason);
      },
    );
  }

  public request<T = any>(
    options: AxiosRequestConfig,
  ): Promise<ApiResponse<T>> {
    return new Promise((resolve, reject) => {
      this.api(options)
        .then((res: AxiosResponse<ApiResponse<T>>) => {
          resolve(res.data);
          return false;
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export const Api = new ApiClient();

export default Api;
